export default "__VITE_ASSET__Bv8_Vkvh__"